import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { ChatBotService } from 'src/Services/chat-bot.service';
import { CommonService } from 'src/Services/common.service';
import { TranslationLoaderService } from 'src/Services/translation-loader.service';
import { LivechatRequestBody } from './models/livechat-request-body';
import { LoginEntryModel } from './models/loginEntry-model';
import { ChatWithExpertService } from './chat-with-expert/service/chat-with-expert.service';
import {EventCollectorService} from "../Services/event-collector.service";
import {GlobalClickTrackingService} from "../Services/global-click-tracking.service";
import { StorageService } from 'src/Services/session-storage.service';
import {AnalyticsService} from "../Services/gtag.service";
import { BASE_MODULES, SHARED_IMPORTS } from './constants/shared-imports';
import { LoggerModule, NGXLogger, NgxLoggerLevel, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { isNullOrUndefined } from './constants/api-enums';
declare const gtag: Function;
@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports:[...BASE_MODULES, SHARED_IMPORTS.routerModule, SHARED_IMPORTS.ngxSpinnerModule],
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'chatbot-ui';
  chatElement: any;
  chatLang: string = "en";
  chatRequestData = new LivechatRequestBody();
  loginEntry: LoginEntryModel = new LoginEntryModel();
  GA_MEASUREMENT_ID : any;
  constructor(public route:Router, private services: ChatBotService, private localStorage: StorageService,
    private commonService: CommonService, private translator: TranslationLoaderService,private analyticsService : AnalyticsService, 
    private router:Router, private chatWithExpertService: ChatWithExpertService,private eventCollectorService: EventCollectorService, 
    private  globalClickTrackingService : GlobalClickTrackingService, private logger: NGXLogger) {
      window.addEventListener(
        'message',
        (e) => {
          this.receiveMessage(e);
        },
        false,
      );
      this.services.getEnvironmentProperties().subscribe(data =>{
        this.GA_MEASUREMENT_ID = data.ga_key;
        this.analyticsService.startCollecting();
        if(data.eventTracing === 'true'){
          this.eventCollectorService.startCollecting();
          this.globalClickTrackingService.startTracking();
        }
      })

  }


  ngOnInit(){
    this.addGAScript()
    this.getLoggerLevel();
    this.chatElement = document.location.hash.split('?')[1];
    if (this.chatElement && this.chatElement != '') {
      let params = new URLSearchParams(this.chatElement);
      if (params.get('currLang') && (params.get('currLang') === 'es_US' || params.get('currLang') === 'es')) {
        this.chatLang = 'es';
      } else {
        this.chatLang = 'en';
      }
     this.localStorage.setLocalStorageItem('lang', this.chatLang);
      if (params.get('target') && params.get('target') === 'no-account-livechat' ) {
        this.commonService.userLoggedIn = 'true';
      }
      if (params.get('abAccess') && params.get('abAccess') === 'true' ) {
        this.commonService.userLoggedIn = 'false';
      }
      if(params.get('src') && params.get('src') === 'mob'){
        this.localStorage.setSessionStorageItem('isMobileApp', 'true');
        this.commonService.changeisMobileApp(true);
      }
      this.commonService.changestorePageName(params.get('pagename')!)
    }
    const displayTextLang = this.chatLang === 'es'? 'es_US': 'en_US';

        this.services.getChatLabels(displayTextLang).subscribe(response => {
          // this.cpCommonService.showContent = response;
          this.translator.loadTranslations(this.chatLang, response);
      });


  }
  private getLoggerLevel(): void {
    this.services.getEnvironmentProperties().subscribe((res) => {
      if (res) {
        // Set the logger level in session and need to update to dynamic value after db script execution
        // Get the current config
        const config = this.logger.getConfigSnapshot();
        // Updating only one field
        config.serverLogLevel = NgxLoggerLevel.INFO
        // Setting the config
        this.logger.updateConfig(config);
      }
    });
  }

  receiveMessage(e: MessageEvent): void {
    try {
      const data = JSON.parse(e.data);
      const channel = data.channel;
      const newChannel = data.newChannel;

      if('CPProfileChannel' === newChannel){
				this.displayProfiles(data.profiles);
				}


      if ('CPChildChannel' === channel) {
        // this.redirectFloraForVerify();
      } else if ('CPNavigateProfileChannel' === channel) {
        // this.navigatePerProfile(data);
      } else if ('VisitorCloseSuccess' === channel) {
        localStorage.removeItem('minimizeUrl');
        this.commonService.removeiframeOpen();
        this.commonService.changeDisplay('');
        window.parent.postMessage({ messageType: 'chatState', chatOpen: false }, "*");
        parent.postMessage('Botclose', '*');
        this.router.navigateByUrl('chatloader')
      }else if ('ParentChannel' === channel) {
        this.commonService.removeiframeOpen();
				this.reverifyChat(data);
			}
      if('ParentFeedbackChannel' === channel) {
       this.commonService.removeiframeOpen();
			}
    } catch (ex) { }
  }

  displayProfiles( data: any ) {
    this.commonService.setProfileData(data);
    window.parent.postMessage({ messageType: 'chatState', chatOpen: true }, "*");
      this.route.navigateByUrl('chat/landing');
      parent.postMessage('Expand', '*');
  }

  reverifyChat(data:any) {
    this.commonService.reverify = true;
    this.commonService.chatId = data.chatId?data.chatId: '';
    this.commonService.hash = data.hash?data.hash: '';
    if (this.commonService.userLoggedIn === 'true') {
      this.services.getUserDetails('', this.commonService.userLoggedIn,
        '').subscribe(data => {

          if (data?.encData) {
           this.initChat(data.encData);
          }
          this.services.doLogout();
      });
      this.router.navigateByUrl('liveChat/agentWindow');
    }else {
      this.router.navigateByUrl('liveChat/accountRelatedQuestions');
    }
  }

  initChat(encData: any) {
    let url = null;
    this.services.getEnvironmentProperties().subscribe(data => {
      url = data.liveChatUrl;
    });
    if (this.commonService.reverify) {
      url = url + '/restapi/mhc-update-enc-data';
    } else {
      url = url + '/restapi/mhc-start-chat';

    }
    this.buildInitChatRequest(encData);
    this.chatWithExpertService.connectWithAgentCreds(url,this.chatRequestData).subscribe(data=>{
      if ( data.result.id ) {
        this.chatWithExpertService.chatId = data.result.id ;
      }
      if ( data.result.hash ) {
        this.chatWithExpertService.hashId = data.result.hash;
      }
      this.router.navigateByUrl('liveChat/agentWindow');
    });

  }

  buildInitChatRequest(encrptedData: any) {
    let msg = 'Login with your account';
    let srcSystem = 'MHC';
	  if (this.commonService.userLoggedIn) {
		  srcSystem = 'CP';
	  }



    if (this.commonService.reverify) {
        this.chatRequestData.chat_id =this.commonService.chatId;
        this.chatRequestData.hash= this.commonService.hash;
        this.chatRequestData.encData = encrptedData

    }  else {

      this.chatRequestData.ignore_required = true;
      this.chatRequestData.ignore_bot = false;
      this.chatRequestData.fields.Question = msg;
      this.chatRequestData.encData = encrptedData;
        this.chatRequestData.sourceSystem =srcSystem;

    }
  }
  ngOnDestroy(): void {
     this.eventCollectorService.stopCollectingEvents();
     this.globalClickTrackingService.stopTrackingClicks();
     this.analyticsService.stopCollectingEvents();
  }
   /** Add Google Analytics Script & MEASUREMENT ID dynamically */
   addGAScript() {
    let gtagScript: HTMLScriptElement = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.GA_MEASUREMENT_ID;
    document.head.prepend(gtagScript);
    /** Disable automatic page view hit to fix duplicate page view count  **/
    gtag('config', this.GA_MEASUREMENT_ID, { send_page_view: false });
  }

}
